import React from 'react';

import TestImg1w from "./../Images/profile1.webp";
import TestImg1 from "./../Images/profile1.jpg";
import TestImg2w from "./../Images/profile1.webp";
import TestImg2 from "./../Images/profile1.jpg";
import TestImg3w from "./../Images/profile1.webp";
import TestImg3 from "./../Images/profile1.jpg";
import TestImg4w from "./../Images/profile4.webp";
import TestImg4 from "./../Images/profile4.jpg";
import TestImg5w from "./../Images/profile5.webp";
import TestImg5 from "./../Images/profile5.jpg";

import TestLgo1w from "./../Images/clients/test7.webp";
import TestLgo1 from "./../Images/clients/test7.png";
import TestLgo2w from "./../Images/clients/test6.webp";
import TestLgo2 from "./../Images/clients/test6.png";
import TestLgo3w from "./../Images/clients/test2.webp";
import TestLgo3 from "./../Images/clients/test2.png";

import TestLgo4w from "./../Images/clients/test4.webp";
import TestLgo4 from "./../Images/clients/test4.png";
import TestLgo5w from "./../Images/clients/test5.webp";
import TestLgo5 from "./../Images/clients/test5.png";

const TestList1 = [
    { srset1: TestImg1w, srset2: TestImg1, name: "Durai Saravanan", post: "", lgoset1: TestLgo1w, lgoset2: TestLgo1, logo: "Kans One", test: "ZYX Media has been a game-changer for us, delivering exceptional digital marketing and social media results. Their team is highly professional, responsive, and truly invested in our success. They understood our goals and executed with creativity, strategy, and clear communication. If you seek quality and reliability, ZYX is a partner you can trust." },	
    { srset1: TestImg2w, srset2: TestImg2, name: "Doz", post: "", lgoset1: TestLgo2w, lgoset2: TestLgo2, logo: "Let's Play", test: "We have been working with ZYX MEDIA for all our digital marketing needs, and the experience has been exceptional. From social media and SEO to paid ads and content strategy, their team has consistently delivered creative, data-driven solutions that have boosted our brand visibility and engagement. Their proactive approach, quick turnaround, and deep understanding of our goals make them a trusted and valuable partner. I highly recommend ZYX MEDIA to anyone looking for a reliable digital marketing team." },	
    { srset1: TestImg3w, srset2: TestImg3, name: "Ganesh Raja", post: "", lgoset1: TestLgo3w, lgoset2: TestLgo3, logo: "Super Auto Forge", test: "ZYX Media delivered exceptional product display photography with perfect lighting, styling, and detail that elevated our catalog. Their professionalism, creativity, and smooth communication made the entire process seamless. We're delighted with the results and highly recommend them for high-quality product visuals." },
]
const TestList2 = [    
    { srset1: TestImg4w, srset2: TestImg4, name: "Jayasree", post: "Founder, Maynee", lgoset1: TestLgo4w, lgoset2: TestLgo4, logo: "Maynee", test: "From brand identity to social media management, their work truly reflects our clinic’s quality." },
    { srset1: TestImg5w, srset2: TestImg5, name: "Aneesh Noor Mohammed", post: "Founder, ANM Classes", lgoset1: TestLgo5w, lgoset2: TestLgo5, logo: "ANM Classes", test: "Video content strategies have added immense value to our brand." },
	{ srset1: TestImg3w, srset2: TestImg3, name: "Ganesh Raja", post: "", lgoset1: TestLgo3w, lgoset2: TestLgo3, logo: "Super Auto Forge", test: "ZYX Media delivered exceptional product display photography with perfect lighting, styling, and detail that elevated our catalog. Their professionalism, creativity, and smooth communication made the entire process seamless. We're delighted with the results and highly recommend them for high-quality product visuals." },
]

export default function Testimonial() {
    return (
        <div className='testimonial-cont sectin bg-pattern fix'>
            <div className='container-fluid'>
                <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>What our clients say...</h2>
                <div className='mxw-700 m-lg-auto txt-lg-center txt-lt mb-8' data-aos="fade-down" data-aos-once='true'><p className='f-18 mb-0 line-ht-24'>Real stories, real results. Hear how ZYX Media helped brands grow, connect, and stand out across the digital landscape.</p></div>
            </div>
            <div className='test-slider'>
                <div className='test-slider-track'>
                    {TestList1.map((item, index) => {
                        return (
                            <div key={index} className='test-slide' data-aos="fade-up" data-aos-once='true'>
                                <div className='test-info'>
                                    <div className='test-profile'>
                                        <picture>
                                            <source srcSet={item.srset1} type="image/webp" />
                                            <source srcSet={item.srset2} type="image/jpeg" />
                                            <img
                                                src={item.srset2}
                                                alt={item.name}
                                                title={item.name}
                                                width="96"
                                                height="96"
                                            />
                                        </picture>
                                    </div>
                                    <div className='test-name f-18 txt-white mb-0'>{item.name}, <span className='txt-white-60 d-blk line-ht-20'>{item.post}</span></div>
                                </div>
                                <div className='test-company'>
                                    <picture>
                                        <source srcSet={item.lgoset1} type="image/webp" />
                                        <source srcSet={item.lgoset2} type="image/jpeg" />
                                        <img
                                            src={item.lgoset2}
                                            alt={item.logo}
                                            title={item.logo}
                                            width="221"
                                            height="96"
                                        />
                                    </picture>
                                </div>
                                <div className='clear'></div>
                                <div className='test-txt f-18 txt-white line-ht-24 mb-3' data-col="eq-ht4">" {item.test} "</div>
                                <div className='test-rating'></div>
                            </div>
                        )
                    })}
                    {TestList1.map((item, index) => {
                        return (
                            <div key={index} className='test-slide' data-aos="fade-up" data-aos-once='true'>
                                <div className='test-info'>
                                    <div className='test-profile'>
                                        <picture>
                                            <source srcSet={item.srset1} type="image/webp" />
                                            <source srcSet={item.srset2} type="image/jpeg" />
                                            <img
                                                src={item.srset2}
                                                alt={item.name}
                                                title={item.name}
                                                width="96"
                                                height="96"
                                            />
                                        </picture>
                                    </div>
                                    <div className='test-name f-18 txt-white mb-0'>{item.name}, <span className='txt-white-60 d-blk line-ht-20'>{item.post}</span></div>
                                </div>
                                <div className='test-company'>
                                    <picture>
                                        <source srcSet={item.lgoset1} type="image/webp" />
                                        <source srcSet={item.lgoset2} type="image/jpeg" />
                                        <img
                                            src={item.lgoset2}
                                            alt={item.logo}
                                            title={item.logo}
                                            width="221"
                                            height="96"
                                        />
                                    </picture>
                                </div>
                                <div className='clear'></div>
                                <div className='test-txt f-18 txt-white line-ht-24 mb-3' data-col="eq-ht4">" {item.test} "</div>
                                <div className='test-rating'></div>
                            </div>
                        )
                    })}
                    <div className='clear'></div>
                </div>
            </div>
            <div className='test-slider2 mt-6'>
                <div className='test-slider-track'>
                    {TestList2.map((item, index) => {
                        return (
                            <div key={index} className='test-slide' data-aos="fade-up" data-aos-once='true'>
                                <div className='test-info'>
                                    <div className='test-profile'>
                                        <picture>
                                            <source srcSet={item.srset1} type="image/webp" />
                                            <source srcSet={item.srset2} type="image/jpeg" />
                                            <img
                                                src={item.srset2}
                                                alt={item.name}
                                                title={item.name}
                                                width="96"
                                                height="96"
                                            />
                                        </picture>
                                    </div>
                                    <div className='test-name f-18 txt-white mb-0'>{item.name}, <span className='txt-white-60 d-blk line-ht-20'>{item.post}</span></div>
                                </div>
                                <div className='test-company'>
                                    <picture>
                                        <source srcSet={item.lgoset1} type="image/webp" />
                                        <source srcSet={item.lgoset2} type="image/jpeg" />
                                        <img
                                            src={item.lgoset2}
                                            alt={item.logo}
                                            title={item.logo}
                                            width="221"
                                            height="96"
                                        />
                                    </picture>
                                </div>
                                <div className='clear'></div>
                                <div className='test-txt f-18 txt-white line-ht-24 mb-3' data-col="eq-ht5">" {item.test} "</div>
                                <div className='test-rating'></div>
                            </div>
                        )
                    })}
                    {TestList2.map((item, index) => {
                        return (
                            <div key={index} className='test-slide' data-aos="fade-up" data-aos-once='true'>
                                <div className='test-info'>
                                    <div className='test-profile'>
                                        <picture>
                                            <source srcSet={item.srset1} type="image/webp" />
                                            <source srcSet={item.srset2} type="image/jpeg" />
                                            <img
                                                src={item.srset2}
                                                alt={item.name}
                                                title={item.name}
                                                width="96"
                                                height="96"
                                            />
                                        </picture>
                                    </div>
                                    <div className='test-name f-18 txt-white mb-0'>{item.name}, <span className='txt-white-60 d-blk line-ht-20'>{item.post}</span></div>
                                </div>
                                <div className='test-company'>
                                    <picture>
                                        <source srcSet={item.lgoset1} type="image/webp" />
                                        <source srcSet={item.lgoset2} type="image/jpeg" />
                                        <img
                                            src={item.lgoset2}
                                            alt={item.logo}
                                            title={item.logo}
                                            width="221"
                                            height="96"
                                        />
                                    </picture>
                                </div>
                                <div className='clear'></div>
                                <div className='test-txt f-18 txt-white line-ht-24 mb-3' data-col="eq-ht5">" {item.test} "</div>
                                <div className='test-rating'></div>
                            </div>
                        )
                    })}
                    <div className='clear'></div>
                </div>
            </div>
        </div>
    )
}
